import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "w-full flex items-center justify-between p-4" };
const _hoisted_2 = { class: "flex-1 w-full p-6 flex flex-col items-center justify-center" };
const _hoisted_3 = {
    key: 0,
    class: "bg-white p-4 rounded-[12px] shadow-lg border border-gray-200"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 1,
    class: "mt-4 text-center text-sm text-hint line-clamp-2"
};
const _hoisted_6 = { class: "w-full p-4" };
const _hoisted_7 = ["disabled"];
import { ref, watch, computed } from "vue";
import QRCode from "qrcode";
import { X, Download } from "lucide-vue-next";
import { useHomeStore } from "./homeStore";
// MARK: Store usage
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-qr-dialog',
    setup(__props) {
        const homeStore = useHomeStore();
        // MARK: Ref value
        const showContent = ref(false);
        const qrCodeUrl = ref("");
        const isDownloading = ref(false);
        // MARK: Computed
        const listingTitle = computed(() => {
            if (!homeStore.qrDialogItem)
                return "";
            const item = homeStore.qrDialogItem;
            if (item.type === "Buy") {
                return item.title ?? "";
            }
            const parts = [item.brand ?? ""];
            if (item.model)
                parts.push(` ${item.model}`);
            if (item.model_series)
                parts.push(` ${item.model_series}`);
            return parts.join("");
        });
        // MARK: Function
        const generateQRCode = async () => {
            if (!homeStore.qrDialogItem) {
                qrCodeUrl.value = "";
                return;
            }
            const item = homeStore.qrDialogItem;
            const url = `https://${window.location.host}/listing/${item.id}`;
            try {
                qrCodeUrl.value = await QRCode.toDataURL(url, {
                    width: 256,
                    margin: 2,
                    color: {
                        dark: "#000000",
                        light: "#FFFFFF",
                    },
                });
            }
            catch (error) {
                console.error("Failed to generate QR code:", error);
                qrCodeUrl.value = "";
            }
        };
        // Watch for when the dialog becomes visible
        watch(() => homeStore.showQRDialog, (newValue) => {
            if (newValue) {
                setTimeout(() => {
                    document.body.style.overflow = "hidden";
                    showContent.value = true;
                    generateQRCode();
                }, 100);
            }
        });
        const closeDialog = () => {
            showContent.value = false;
            setTimeout(() => {
                document.body.style.overflow = "";
                homeStore.showQRDialog = false;
                homeStore.qrDialogItem = null;
                qrCodeUrl.value = "";
            }, 100);
        };
        const downloadQRCode = async () => {
            if (!qrCodeUrl.value || isDownloading.value)
                return;
            isDownloading.value = true;
            try {
                // Convert base64 to blob
                const response = await fetch(qrCodeUrl.value);
                const blob = await response.blob();
                // Sanitize filename from title
                const filename = listingTitle.value
                    .replace(/[\\/:*?"<>|]/g, "") // Remove invalid filename chars
                    .replace(/\s+/g, "-") // Replace spaces with hyphens
                    .substring(0, 100); // Limit length
                // Create download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `${filename}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
            catch (error) {
                console.error("Failed to download QR code:", error);
            }
            finally {
                isDownloading.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_unref(homeStore).showQRDialog)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "fixed left-0 top-0 z-50 h-[var(--safe-height)] w-full bg-black/30 backdrop-blur-sm flex items-center justify-center",
                    onClick: _cache[3] || (_cache[3] = ($event) => (closeDialog()))
                }, [
                    _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100 transform",
                        "enter-from-class": "opacity-0 scale-95",
                        "enter-to-class": "opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75 transform",
                        "leave-from-class": "opacity-100 scale-100",
                        "leave-to-class": "opacity-0 scale-95"
                    }, {
                        default: _withCtx(() => [
                            (showContent.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "w-11/12 bg-white rounded-[20px] border border-badge flex flex-col justify-start items-center max-w-[400px]",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["stop"]))
                                }, [
                                    _createElementVNode("div", _hoisted_1, [
                                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "size-8" }, null, -1)),
                                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-2xl font-medium text-badge" }, "QR Code", -1)),
                                        _createVNode(_unref(X), {
                                            class: "size-8 text-badge cursor-pointer",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (closeDialog()))
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_2, [
                                        (qrCodeUrl.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                                _createElementVNode("img", {
                                                    src: qrCodeUrl.value,
                                                    alt: "QR Code",
                                                    class: "size-64"
                                                }, null, 8, _hoisted_4)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_unref(homeStore).qrDialogItem)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(listingTitle.value), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("button", {
                                            onClick: _cache[1] || (_cache[1] = ($event) => (downloadQRCode())),
                                            disabled: isDownloading.value,
                                            class: "w-full py-3 bg-badge text-white rounded-[8px] font-medium text-base flex items-center justify-center gap-2 disabled:opacity-50"
                                        }, [
                                            _createVNode(_unref(Download), { size: 20 }),
                                            _createTextVNode(" " + _toDisplayString(isDownloading.value ? "Downloading..." : "Download QR Code"), 1)
                                        ], 8, _hoisted_7)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ]))
                : _createCommentVNode("", true);
        };
    }
});
